export const RECEIVE_SESSION_ID = 'RECEIVE_SESSION_ID'
export const RECEIVE_LOGIN_STATE = 'RECEIVE_LOGIN_STATE'
export const SET_IS_APP = 'SET_IS_APP'
export const TAB_BAR_MY_BADGE = 'TAB_BAR_MY_BADGE'
export const TAB_BAR_ZERO_BADGE = 'TAB_BAR_ZERO_BADGE'
export const TAB_BAR_SHOW = 'TAB_BAR_SHOW'
export const SET_SORT_INDEX = 'SET_SORT_INDEX'
// export const SET_SUBMIT_INFO = 'SET_SUBMIT_INFO'
export const SET_SOHO_INFO = 'SET_SOHO_INFO'
export const SET_PORTRAIT_URL = 'SET_PORTRAIT_URL'
export const LOGINDIALOG_SHOW = 'LOGINDIALOG_SHOW'
export const QR_CODE_IS_SHOW = 'QR_CODE_IS_SHOW'
export const CUR_PRODUCT_ID = 'CUR_PRODUCT_ID'
export const SHIELD_DIALOG_SHOW = 'SHIELD_DIALOG_SHOW'
export const HAD_SHIELD = 'HAD_SHIELD'
export const SET_BEHAVIOR_SCORE = 'SET_BEHAVIOR_SCORE'
export const SET_TOTAL_VIOLATIONP_COUNT = 'SET_TOTAL_VIOLATIONP_COUNT'
export const SET_IS_AUTHORIZED = 'SET_IS_AUTHORIZED'
export const AUTHORIZE_POPUP_SHOW = 'AUTHORIZE_POPUP_SHOW'
export const SET_NEW_PERSON_FREE_ORDER_COUNT = 'SET_NEW_PERSON_FREE_ORDER_COUNT'
export const SET_GOODS_DETAIL_DATA = 'SET_GOODS_DETAIL_DATA'
export const SET_IOS_IS_SHOW_LOGIN_BTN = 'SET_IOS_IS_SHOW_LOGIN_BTN'
export const SET_MANAGEBTN_IS_OPEN = 'SET_MANAGEBTN_IS_OPEN'
export const SET_ALL_CHOSED_IS_OPEN = 'SET_ALL_CHOSED_IS_OPEN'
export const SET_EFFECTIVE_GOODS_LIST_INFO = 'SET_EFFECTIVE_GOODS_LIST_INFO'
export const SET_INEFFECTIVE_LIST_INFO = 'SET_INEFFECTIVE_LIST_INFO'
export const SET_ALL_CHOOSE_BTN_SWITCH_INFO = 'SET_ALL_CHOOSE_BTN_SWITCH_INFO'
export const SET_IS_HAVE_UNFINISHED_ORDER = 'SET_IS_HAVE_UNFINISHED_ORDER'
export const SET_TEMP_ORDER_INFO = 'SET_TEMP_ORDER_INFO'
export const SET_IS_HORIZONTAL_SCREEN = 'SET_IS_HORIZONTAL_SCREEN'
export const SET_QRCODE_POPUP = 'SET_QRCODE_POPUP'
export const SET_GUIDE_EVALUATION_POPUP = 'SET_GUIDE_EVALUATION_POPUP'
export const SET_CONFIG_ACCURATE_MODE = 'SET_CONFIG_ACCURATE_MODE'
export const SET_ACCURATE_MODE = 'SET_ACCURATE_MODE'
